<div class="banner-container text-center">
  <div class="input-group mb-search-container">
    <input #text type="text" id="search" placeholder="What would you like to do today?" 
    (input)="onValueChange(text.value)" autocomplete="off"
    [matAutocomplete]="autoComplete"
    (keyup.enter)="searchGlobal(text.value);" [(ngModel)]="speechData" class="form-control" />
    <span class="input-group-addon search-addon">
      <ng-container *ngIf="!isBusy">
        <mat-icon id="microfon-ic" title='Search by voice' (click)="activateSpeech()">keyboard_voice</mat-icon>
      </ng-container>
      <!-- <a *ngIf="!isBusy" id="search-ic" (click)="searchGlobal(text.value)" title="Search">
        <img src="../../assets/images/search.png" />
      </a> -->
      <div *ngIf="!isBusy" id="search-ic" (click)="searchGlobal(text.value)" title="Search">
          <mat-icon>search</mat-icon>
      </div>
      <div *ngIf="isBusy" class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </span>

    <mat-autocomplete #autoComplete="matAutocomplete" class="khamis-autocomplete">
      <mat-option *ngIf="isSearching" class="is-loading" [disabled]="true">
        <mat-spinner diameter="20" style="float:left"></mat-spinner>
        <span style="display: block;margin-left: 30px;font-size: 15px;">Searching...</span>
      </mat-option>
      <ng-container *ngIf="!isSearching">
        <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion"
        (mouseenter)="mouseEnter(suggestion)" (mouseleave)="mouseLeave()">
        {{suggestion}}
        </mat-option>
        <mat-option style="display: none;"></mat-option>
      </ng-container>
    </mat-autocomplete>

  </div>
</div>
